import { render } from "./App.vue?vue&type=template&id=aed241f0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=aed241f0&lang=less"

import exportComponent from "D:\\gitdaima\\aibox-guanlixitong\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__